import React from "react";
import EasyButton from "./easy-button";
import "./easy-link.scss";
import { Link } from "react-router-dom";

interface EasyLinkProps {
    title: string;
    link: string;
}
interface EasyLinkState {
    IsVisibleBookDetail: boolean;
}

class EasyLink extends React.Component<EasyLinkProps, EasyLinkState>{
    constructor(props: any) {
        super(props);
        this.state = {
            IsVisibleBookDetail: false
        };
    }

    render() {
        return (
            <div className="easy-link-content">
                <Link to={this.props.link}>
                    <EasyButton
                        title={this.props.title}
                    />
                </Link>
            </div>
        );
    }
}

export default EasyLink;